import * as React from "react";

const SvgExclamationcircle = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M12 8v4M12 15v.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </g>
  </svg>
);

export default SvgExclamationcircle;
